module.exports = __webpack_public_path__ + "img/passive-skills.1a0cf969.png";